export default __webpack_public_path__ + "static/media/hulk.c5e62849.png";